import { ErrorMessage } from "formik";
import { cn } from "src/lib/utils";

const CustomCheckBox = ({ label, id, type = "radio", labelClassName, name, ...props }) => {
	return (
		<div>
			<div className="tw-flex tw-items-center tw-gap-3">
				<input id={id} type={type} name={name} {...props} className={cn("tw-accent-primary", props.className)} />
				<label htmlFor={id} className={cn("tw-cursor-pointer tw-select-none tw-text-sm tw-font-normal tw-text-[#333333]", labelClassName)}>
					{label}
				</label>
			</div>
			{!!name && <ErrorMessage name={name} component="div" className="tw-block tw-mt-1 tw-text-xs tw-text-destructive" />}
		</div>
	);
};

export default CustomCheckBox;
